/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUserTasksBulkResponse
 */
export interface CreateUserTasksBulkResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUserTasksBulkResponse
     */
    taskIds: Array<string>;
}

/**
 * Check if a given object implements the CreateUserTasksBulkResponse interface.
 */
export function instanceOfCreateUserTasksBulkResponse(value: object): value is CreateUserTasksBulkResponse {
    if (!('taskIds' in value) || value['taskIds'] === undefined) return false;
    return true;
}

export function CreateUserTasksBulkResponseFromJSON(json: any): CreateUserTasksBulkResponse {
    return CreateUserTasksBulkResponseFromJSONTyped(json, false);
}

export function CreateUserTasksBulkResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUserTasksBulkResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'taskIds': json['taskIds'],
    };
}

export function CreateUserTasksBulkResponseToJSON(json: any): CreateUserTasksBulkResponse {
    return CreateUserTasksBulkResponseToJSONTyped(json, false);
}

export function CreateUserTasksBulkResponseToJSONTyped(value?: CreateUserTasksBulkResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'taskIds': value['taskIds'],
    };
}

